import React, {useEffect, useRef} from 'react'
import {useCustomerId} from '@salesforce/commerce-sdk-react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {useWishlistActions} from '../../../hooks/use-wishlist-actions'

const PendingWishlistReplay = () => {
    const customerId = useCustomerId()
    const {data: customer} = useCurrentCustomer()
    const {addItemToWishlist, isInWishlist} = useWishlistActions()
    const pendingWishlistReplayRef = useRef(null)

    useEffect(() => {
        if (typeof window === 'undefined') return
        if (!customer?.isRegistered || !customerId) return

        const pendingProductId = window.sessionStorage.getItem('pendingWishlistProductId')
        if (!pendingProductId) {
            pendingWishlistReplayRef.current = null
            return
        }

        if (pendingWishlistReplayRef.current === pendingProductId) return

        pendingWishlistReplayRef.current = pendingProductId

        if (isInWishlist(pendingProductId)) {
            window.sessionStorage.removeItem('pendingWishlistProductId')
            return
        }

        addItemToWishlist({productId: pendingProductId})
    }, [customer?.isRegistered, customerId, isInWishlist, addItemToWishlist])

    return null
}

export default PendingWishlistReplay
